import olympicCase from "./stage1/olympics.png";
import paralympicCase from "./stage1/paralympics.png";
import asianCase from "./stage1/asian_games.png";
import commonwealthCase from "./stage1/common_wealth_games.png";

import olympic1 from "./stage1/Olympic1.png";
import olympic2 from "./stage1/Olympic2.png";
import paralympic1 from "./stage1/Paralympic1.png";
import paralympic2 from "./stage1/Paralympic2.png";
import asian1 from "./stage1/Asian1.png";
import asian2 from "./stage1/Asian2.png";
import commonwealth1 from "./stage1/Commonwealth1.png";
import commonwealth2 from "./stage1/Commonwealth2.png";

/** Points written to DB `stage1` on successful restore. */
export const MEDAL_DISPLAY_POINTS = 100;

/** Session key: unlocked hall hotspot ids after puzzles. */
export const HALL1_UNLOCKED_KEY = "hall1_unlocked_hotspots";
export const HALL1_COMPLETED_KEY = "hall1_completed_hotspots";

export const MEDAL_CATEGORIES = [
  {
    id: "olympic",
    label: "Olympic Games",
    shortLabel: "Olympics",
    image: olympicCase,
  },
  {
    id: "paralympic",
    label: "Paralympic Games",
    shortLabel: "Paralympics",
    image: paralympicCase,
  },
  {
    id: "asian",
    label: "Asian Games",
    shortLabel: "Asian Games",
    image: asianCase,
  },
  {
    id: "commonwealth",
    label: "Commonwealth Games",
    shortLabel: "Commonwealth",
    image: commonwealthCase,
  },
];

export const MEDAL_ITEMS = [
  {
    id: "neeraj_chopra",
    name: "Neeraj Chopra",
    detail: "Men's Javelin Gold",
    categoryId: "olympic",
    image: olympic1,
  },
  {
    id: "pv_sindhu",
    name: "PV Sindhu",
    detail: "Women's Singles Silver",
    categoryId: "olympic",
    image: olympic2,
  },
  {
    id: "sumit_antil",
    name: "Sumit Antil",
    detail: "Men's Javelin Gold",
    categoryId: "paralympic",
    image: paralympic1,
  },
  {
    id: "avani_lekhara",
    name: "Avani Lekhara",
    detail: "Women's 10m Air Rifle Gold",
    categoryId: "paralympic",
    image: paralympic2,
  },
  {
    id: "jyothi_yarraji",
    name: "Jyothi Yarraji",
    detail: "100m Hurdles Gold",
    categoryId: "asian",
    image: asian1,
  },
  {
    id: "mens_cricket",
    name: "Indian Men's Cricket Team",
    detail: "Gold",
    categoryId: "asian",
    image: asian2,
  },
  {
    id: "sharath_kamal",
    name: "Achanta Sharath Kamal",
    detail: "Table Tennis Gold",
    categoryId: "commonwealth",
    image: commonwealth1,
  },
  {
    id: "womens_cricket",
    name: "Indian Women's Cricket Team",
    detail: "Gold",
    categoryId: "commonwealth",
    image: commonwealth2,
  },
];

/** Puzzle 2 hotspot unlocked after Medal Display success. */
export const MEDAL_DISPLAY_UNLOCKS = "commentary_booth";

/** Hall hotspot order ↔ DB columns stage1 … stage5 */
export const HALL1_HOTSPOT_ORDER = [
  "medal_display",
  "commentary_booth",
  "museum_archive",
  "newspaper",
  "trophy_vault",
];

/** True when stages.stageN has a saved score (not null / empty). */
export function isHallStageScorePresent(stage, stageNumber) {
  if (!stage || stageNumber < 1) return false;
  const value = stage[`stage${stageNumber}`];
  return value != null && value !== "";
}

/** Routes for Hall of Champions stages 1–6. */
export const HALL1_STAGE_ROUTES = {
  1: "/hall-1/stage1",
  2: "/hall-1/stage2",
  3: "/hall-1/stage3",
  4: "/hall-1/stage4",
  5: "/hall-1/stage5",
  6: "/hall-1/stage6",
};

/**
 * If this stage already has a DB score, skip to the next incomplete stage
 * (or /hall-2 when Hall of Champions is fully done). Returns null to stay.
 */
export function getRedirectIfHall1StageDone(stage, stageNumber) {
  if (!isHallStageScorePresent(stage, stageNumber)) return null;
  for (let n = stageNumber + 1; n <= 6; n += 1) {
    if (!isHallStageScorePresent(stage, n)) {
      return HALL1_STAGE_ROUTES[n] || "/hall-1";
    }
  }
  return "/hall-2";
}

/** Hub redirect when Hall of Champions is fully restored. */
export function getHall1HubRedirect(stage) {
  if (!stage) return null;
  if (isHallStageScorePresent(stage, 6)) return "/hall-2";
  return null;
}

/**
 * Only one hotspot is clickable: the first puzzle whose DB score is still empty.
 * Stages 1–5 map to the five SVG hotspots. Stage 6 reuses `trophy_vault`
 * (no sixth SVG id) once stage5 is complete.
 */
export function resolveActiveHall1Hotspot(stage) {
  for (let i = 0; i < HALL1_HOTSPOT_ORDER.length; i += 1) {
    if (!isHallStageScorePresent(stage, i + 1)) {
      return HALL1_HOTSPOT_ORDER[i];
    }
  }
  if (!isHallStageScorePresent(stage, 6)) {
    return "trophy_vault";
  }
  return null;
}

/**
 * Which route trophy_vault should open, based on DB progress.
 * stage5 empty → newspaper investigation; else → stage6 finale.
 */
export function resolveTrophyVaultRoute(stage) {
  if (!isHallStageScorePresent(stage, 5)) return "/hall-1/stage5";
  if (!isHallStageScorePresent(stage, 6)) return "/hall-1/stage6";
  return null;
}

export function readHall1Unlocked() {
  try {
    const raw = sessionStorage.getItem(HALL1_UNLOCKED_KEY);
    const parsed = raw ? JSON.parse(raw) : ["medal_display"];
    return Array.isArray(parsed) ? parsed : ["medal_display"];
  } catch {
    return ["medal_display"];
  }
}

export function unlockHall1Hotspot(id) {
  const set = new Set(readHall1Unlocked());
  set.add(id);
  sessionStorage.setItem(HALL1_UNLOCKED_KEY, JSON.stringify([...set]));
}

export function readHall1Completed() {
  try {
    const raw = sessionStorage.getItem(HALL1_COMPLETED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function markHall1HotspotCompleted(id) {
  const set = new Set(readHall1Completed());
  set.add(id);
  sessionStorage.setItem(HALL1_COMPLETED_KEY, JSON.stringify([...set]));
}

/** Mirror DB progress into sessionStorage (optional cache). */
export function hydrateHall1ProgressFromStage(stage) {
  if (!stage) return;

  const unlocked = new Set(["medal_display"]);
  const completed = new Set();

  HALL1_HOTSPOT_ORDER.forEach((id, index) => {
    const stageNumber = index + 1;
    if (isHallStageScorePresent(stage, stageNumber)) {
      // trophy_vault stays active for stage6 until stage6 is saved
      if (id === "trophy_vault" && !isHallStageScorePresent(stage, 6)) {
        unlocked.add(id);
        return;
      }
      completed.add(id);
      const next = HALL1_HOTSPOT_ORDER[index + 1];
      if (next) unlocked.add(next);
    }
  });

  if (
    isHallStageScorePresent(stage, 5) &&
    !isHallStageScorePresent(stage, 6)
  ) {
    unlocked.add("trophy_vault");
  }

  sessionStorage.setItem(HALL1_UNLOCKED_KEY, JSON.stringify([...unlocked]));
  sessionStorage.setItem(HALL1_COMPLETED_KEY, JSON.stringify([...completed]));

  if (isHallStageScorePresent(stage, 6)) {
    sessionStorage.setItem("hall1_complete", "1");
    sessionStorage.setItem("hall2_unlocked", "1");
  }
}
